/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';
import { isIE11 } from './_stringTagBug.js';
import { ie11fingerprint, mapMethods }  from './_methodFingerprint.js';

export default isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isMap.js
// module id = 161
// module chunks = 0